import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const StubWrapper = styled.li`
  display: flex;
  align-items: center;
  width: 100%;
  height: 130px;
  border-bottom: 1px solid ${COLORS.line};
`;

export default StubWrapper;
